import { LoadingSceneBackdrop } from "~mangomap-ui/components/loading-scene/loading-scene-backdrop";
import { DEFAULT_MANGO_LOGO_URL } from "~utils/functions/whitelabel-branding";
import { useRouter } from "next/router";
import { FC, ReactNode, useEffect } from "react";

import { usePartnerAuth } from "../context";
import { getRedirFromQuery, resolvePartnerRedirOrFallback } from "../redir";

interface PartnerRedirectToRootProps {
	children: ReactNode;
}

export const PartnerRedirectOnSignedIn: FC<PartnerRedirectToRootProps> = ({
	children,
}) => {
	const router = useRouter();
	const { isLoading, isAuthenticated } = usePartnerAuth();

	useEffect(() => {
		if (!isLoading && isAuthenticated) {
			void router.replace(
				resolvePartnerRedirOrFallback({
					redir: getRedirFromQuery(router.query),
					fallback: "/portfolios",
				}),
			);
		}
	}, [isLoading, isAuthenticated, router]);

	if (isLoading || isAuthenticated) {
		return <LoadingSceneBackdrop logoUrl={DEFAULT_MANGO_LOGO_URL} />;
	}

	return children;
};
